import Rating from '@/classes/rating';
import Vue from 'vue';

const state = {
  ratings: {},
};

const getters = {
  get: state => state.ratings,
};

const mutations = {
  set(state, ratings) {
    ratings.map(r => new Rating(r)).forEach(rating => {
      Vue.set(state.ratings, rating.key, rating);
    });
  },
};

const actions = {
  create({ dispatch, commit, getters, rootGetters }, params) {
    commit('set', [new Rating(params)]);
    return rootGetters['session/ajax'].post('/ratings', params);
  },
  fetch({dispatch, commit, getters, rootGetters}, params) {
    return rootGetters['session/ajax'].get('/ratings', { params }).then(response => {
      commit('set', response.data.records);
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
